export default __webpack_public_path__ + "static/media/tutorial-09.53bed44a.jpg";